import { useState, useEffect } from 'react';
import { useShowAds } from '../hooks/useShowAds';
import AdsterraBanner from './AdsterraBanner';

const AdBannerPair = () => {
  const { showAds } = useShowAds();
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!showAds) return null;

  return (
    <div className="flex justify-center w-full" data-testid="ad-banner-pair">
      {isMobile ? (
        <AdsterraBanner adKey="33fd54ad9c33de234b037dd94a601f4d" width={320} height={50} testId="ad-banner-1-mobile" marginTop={0} marginBottom={32} />
      ) : (
        <AdsterraBanner adKey="97a6a0881277d3c7f51cd692bd3b60eb" width={468} height={60} testId="ad-banner-1" marginTop={0} marginBottom={32} />
      )}
    </div>
  );
};

export default AdBannerPair;
